<div class="signature-item">
  <div class="signature-item--icon">
    <ion-icon name="alberta-signature"></ion-icon>
  </div>
  <div class="signature-item--content">
    <div [ngClass]="node.mandatory ? 'text-container required-star':'text-container'">
      <div class="text">{{ node.title }} <span *ngIf="node.mandatory">*</span></div>
    </div>
    <img [src]="signatureImage.data" *ngIf="signatureImage" />
    <itl-button class="button-signature" (click)="sign()"> {{ 'audit.node.signature.sign' | translate }} </itl-button>
  </div>
</div>
